import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { AlertCircle } from 'lucide-react';

interface TokenLimitTooltipProps {
  children: React.ReactElement<{ className?: string; disabled?: boolean }>;
  message: string;
  disabled?: boolean;
  side?: 'top' | 'right' | 'bottom' | 'left';
}

export const TokenLimitTooltip: React.FC<TokenLimitTooltipProps> = ({ 
  children, 
  message, 
  disabled = false,
  side = 'bottom' 
}) => {
  if (!disabled) {
    return children;
  }

  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-block w-full">
            {React.cloneElement(children, {
              ...children.props,
              disabled: true,
              className: `${children.props.className || ''} opacity-50 cursor-not-allowed`,
            })}
          </span>
        </TooltipTrigger>
        <TooltipContent 
          side={side} 
          sideOffset={5}
          className="max-w-sm z-50"
          collisionPadding={10}
        >
          <div className="flex items-start gap-2">
            <AlertCircle className="h-4 w-4 text-red-500 mt-0.5 shrink-0" />
            <p className="text-sm">{message}</p>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};